import { SelectChangeEvent } from '@mui/material';
import { CSSProperties } from 'react';
import BkSelect from 'src/components/select/BkSelect';
import BkTextField from 'src/components/textfield/BkTextField';
import StyledLabel from 'src/pages/job-history/styled/StyledLabel';
import { organizationTypes } from 'src/utils/constant';

interface CustomerFiltersProps {
  selectedFilters: { type: string[]; priceSheet: string[]; searchValue: string };
  sheets: { id: string; label: string }[];
  onFilterChange: (event: SelectChangeEvent<string | (string | null)[]>) => void;
  handleSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchTerm: string;
}

const commonStyles = {
  '& .MuiOutlinedInput-notchedOutline': {
    borderRadius: '0.5rem',
    border: '0.0625rem solid #D6D6D6',
  },
};

const wrapperDivStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  gap: '0.625rem',
  width: '100%',
  marginBottom: '0.9375rem',
};

export const CustomerFilters: React.FC<CustomerFiltersProps> = ({
  searchTerm,
  onFilterChange,
  handleSearchChange,
  selectedFilters,
  sheets,
}) => {
  const filterConfig = [
    {
      id: 'type',
      data: organizationTypes,
      label: 'Organization type',
      placeholder: 'Choose',
      width: '12.5rem',
      name: 'type',
    },
    {
      id: 'priceSheet',
      data: sheets,
      label: 'Price Sheet',
      placeholder: 'Choose',
      width: '12.5rem',
      name: 'priceSheet',
    },
  ];

  return (
    <div style={wrapperDivStyles}>
      <div>
        <StyledLabel sx={{ fontWeight: '500' }}>Organization name, Domain</StyledLabel>
        <BkTextField
          value={searchTerm}
          onChange={handleSearchChange}
          name="search"
          error=""
          width="18.75rem"
          customStyles={commonStyles}
          hasCustomSearchIcon
        />
      </div>
      {filterConfig.map(({ id, data, width, label, placeholder, name }) => {
        return (
          <div key={id} style={{ display: 'flex', flexDirection: 'column' }}>
            <StyledLabel>{label}</StyledLabel>
            <BkSelect
              key={id}
              hasLabel={false}
              data={data}
              name={name}
              multiple={true}
              onChange={onFilterChange}
              value={selectedFilters[id as keyof typeof selectedFilters]}
              error=""
              disabled={false}
              width={width}
              placeholder={placeholder}
              customStyles={commonStyles}
            />
          </div>
        );
      })}
    </div>
  );
};
